<template>
  <div>
    <div class="textArea">
      プリクラONへようこそ！<br>
      <span class="textLink" @click="onTerms">利用規約</span>
      と
      <span class="textLink" @click="onPrivacyPolicy">プライバシーポリシー</span>
      に同意の上、<br>
      会員登録してください。
    </div>

    <section-header heading="2" ja="SNSアカウントで登録"/>
    <div class="snsArea">
      <div class="line">
        <v-avatar size="52px" tile @click="openLineDialog = true">
          <v-img src="@/assets/Png/SNS/LINE_SOCIAL_Basic.png"></v-img>
        </v-avatar>
      </div>
      <div class="twitter">
        <v-avatar size="52px" tile @click="openTweetDialog = true">
          <v-img src="@/assets/Png/SNS/Twitter_Social_Icon_Rounded_Square_Color.png"></v-img>
        </v-avatar>
      </div>
    </div>

    <div class="infoLink">
      <div class="link-text" @click="onAboutWeb03">X(旧Twitter)ログインに関するご注意</div>
    </div>

    <section-header heading="2" ja="メールアドレスで登録"/>
      <div class="mailArea">
        <p-text-field
          placeholder="メールアドレス"
          v-model="local"
          @click="onLocalClear">
        </p-text-field>
        <rule v-if="domain === 'それ以外'">@以降も全て入力してください</rule>
        <p-select
          :items="domains"
          v-model="domain">
        </p-select>
      </div>

      <normal-btn :disabled="!validLocal" @click="openDialog = true">確認</normal-btn>
      <text-box title="メールが届かない場合">
        <div>自動的に迷惑メールを振り分けている可能性があるのでご確認ください。</div>
        <div>迷惑メール設定をされている方は、PCからのメールが受信できるよう設定をお願いします。</div>
        <div>ご登録いただいたメールアドレスはアンケート又は弊社の取り扱う広告メール配信のために使用することがあります。</div>
      </text-box>

    <div class="dialog" v-if="openDialog">
      <div class="dialogInner">
        <div class="dialogText">{{local}}<template v-if="domain !== 'それ以外'">{{domain}}</template><br>
        に送信します。<br>
        よろしければ送信ボタンを押してください。</div>
        <div class="dialogBtn">
          <normal-btn @click="onSend">送信</normal-btn>
          <normal-btn @click="openDialog = false">キャンセル</normal-btn>
        </div>
        <button class="closeBtn" @click="openDialog = false"></button>
      </div>
    </div>
    <div class="dialog" v-if="openTweetDialog">
      <div class="dialogInner">
        <div class="dialogText --textCenter">
          プリクラONをご利用頂くには<br>利用規約への同意が必要です。
        </div>
        <div class="dialogBtn">
          <label for="agreement" class="checkBox">
            <input type="checkbox" name="agreement" class="checkBox__input" id="agreement" :checked="isChecked" />
            <span class="checkBox__custom" :class="{checkMark: isChecked}" @click="toggleAgree()"></span>
            <span class="checkBox__terms" @click="goTerms('openTweetDialog')">利用規約</span>
            に同意する
          </label>
          <normal-btn @click="onTwitter()" :disabled="!isChecked">X(旧Twitter)で登録</normal-btn>
        </div>
        <button class="closeBtn" @click="closeSnsDialog('openTweetDialog')"></button>
      </div>
    </div>
    <div class="dialog" v-if="openLineDialog">
      <div class="dialogInner">
        <div class="dialogText --textCenter">
          プリクラONをご利用頂くには<br>利用規約への同意が必要です。
        </div>
        <div class="dialogBtn">
          <label for="agreement" class="checkBox">
            <input type="checkbox" name="agreement" class="checkBox__input" id="agreement" :checked="isChecked" />
            <span class="checkBox__custom" :class="{checkMark: isChecked}" @click="toggleAgree()"></span>
            <span class="checkBox__terms" @click="goTerms('openLineDialog')">利用規約</span>
            に同意する
          </label>
          <normal-btn @click="onLine()" :disabled="!isChecked">LINEで登録</normal-btn>
        </div>
        <button class="closeBtn" @click="closeSnsDialog('openLineDialog')"></button>
      </div>
    </div>
  </div>
</template>

<script>
import SectionHeader from '../components/SectionHeader'
import NormalBtn from '../components/NormalBtn'
import PSelect from '../components/PSelect'
import PTextField from '../components/PTextField'
import Rule from '../components/Rule'
import Line from '../mixins/line'
import Protobuf from '../mixins/protobuf'
import Screen from '@/mixins/screen.js'
import { domains } from "../assets/js/domain"
import Twitter from '../mixins/twitter'
import TextBox from '@/components/TextBox'

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "RegistrationSelection",
  components: {
    NormalBtn,
    PSelect,
    PTextField,
    SectionHeader,
    TextBox,
    Rule
  },
  mixins: [Line, Protobuf, Screen, Twitter],
  data() {
    return {
      local: '',
      domain: '@docomo.ne.jp',
      domains: domains,
      openDialog: false,
      isChecked: false,
      openTweetDialog: false,
      openLineDialog: false,
    }
  },
  computed: {
    validLocal() {
      return 0 < this.local.length && this.local.length < 128
    }
  },
  methods: {
    onPrivacyPolicy() {
      window.open(process.env.VUE_APP_PRIVACY_POLICY_URL)
    },
    onTerms() {
      this.$router.push("/terms")
    },
    onAboutWeb03() {
      this.$router.push("/AboutWeb03")
    },
    onLine() {
      this.getLineOAuthToken()
    },
    async onLineRegistration(token, user_id) {
      const cmdNo = pb.PlayerRegistrationReq.CommandNo.COMMAND_NO
      const message = pb.PlayerRegistrationReq.create({
        authType: pb.PlayerRegistrationReq.AuthType.LINE,
        lineUserId: user_id,
        lineAccessToken: token
      })
      const encoded = pb.PlayerRegistrationReq.encode(message).finish()
      try {
        const decoded = await this.post(cmdNo, encoded)
        if (decoded.status === pb.PlayerRegistrationResp.Status.SUCCESS) {
          await this.$store.dispatch('saveLineAccessToken', token)
          this.login(decoded.token, decoded.mailAddress, decoded.playerId)
          this.onAgreeTerms()
        } else {
          alert("ログインに失敗しました。")
        }
      } catch(e) {
        this.$_error('Error', {
          title: 'SNSアカウントで登録',
          statusCode: 100
        })
      }
    },
    onTwitter() {
      this.getTwitterOAuthToken()
    },
    async onTwitterRegistration(token, secret, user_id) {
      const cmdNo = pb.PlayerRegistrationReq.CommandNo.COMMAND_NO
      const message = pb.PlayerRegistrationReq.create({
        authType: pb.PlayerRegistrationReq.AuthType.TWITTER,
        twitterUserId: user_id,
        twitterAccessToken: token,
        twitterAccessTokenSecret: secret
      })
      const encoded = pb.PlayerRegistrationReq.encode(message).finish()
      try {
        const decoded = await this.post(cmdNo, encoded)
        if (decoded.status === pb.PlayerRegistrationResp.Status.SUCCESS) {
          await this.$store.dispatch('saveTwitterAccessToken', token)
          this.login(decoded.token, decoded.mailAddress, decoded.playerId)
          this.onAgreeTerms()
        } else {
          alert("ログインに失敗しました。")
        }
      } catch (e) {
        this.$_error('Error', {
          title: 'SNSアカウントで登録',
          statusCode: 100
        })
      }
    },
    login(token, mailAddress, playerId) {
      // 利用規約画面や新規登録画面関連の情報をSessionStorageから削除
      sessionStorage.removeItem('UserInfoRegisration3')
      sessionStorage.removeItem('termsReferrer')
      sessionStorage.removeItem('termsFullReferrer')

      this.$store.dispatch('logout')
      const membershipGrade = pb.LoginResp.MembershipGrade.FREE
      this.$store.dispatch('login', { token, membershipGrade, mailAddress, playerId })
      this.$router.push('/')
    },
    onSend() {
      const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web
      const cmdNo = pb.MailAddressRegistrationReq.CommandNo.COMMAND_NO
      let address = null;
      if(this.domain === 'それ以外') {
        address = this.local;
      } else {
        address = this.local + this.domain;
      }
      const message = pb.MailAddressRegistrationReq.create({
        mailAddress: address
      })
      const encoded = pb.MailAddressRegistrationReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          this.openDialog = false;
          if (decoded.status === pb.MailAddressRegistrationResp.Status.SUCCESS) {
            alert( "確認メールを送信しました。")
          } else {
            alert( "確認メールを送信に失敗しました。")
          }
        })
        .catch(() => {
          this.$_error('Error', {
            title: 'メールアドレスで登録',
            statusCode: 100
          })
        })
    },
    onLocalClear() {
      this.local = ''
    },
    goTerms(flagName) {
      sessionStorage.setItem(flagName, true)
      sessionStorage.setItem('termsReferrer', this.$route.path)
      sessionStorage.setItem('termsFullReferrer', this.$route.fullPath)
      this.$router.push("/terms")
    },
    toggleAgree(){
      this.isChecked = !this.isChecked;
    },
    // 利用規約に同意
    onAgreeTerms(){
      localStorage.setItem('isAgreedTerms', false);
      sessionStorage.removeItem('openTweetDialog')
      sessionStorage.removeItem('openLineDialog')

      const cmdNo = pb.KumaMasterSettingReq.CommandNo.COMMAND_NO
      const message = pb.KumaMasterSettingReq.create()
      const encoded = pb.KumaMasterSettingReq.encode(message).finish()
      this.post(cmdNo, encoded).then(decoded => {
        const cmdNo2 = pb.PlayerGeneralInformationReq.CommandNo.COMMAND_NO
        const message2 = pb.PlayerGeneralInformationReq.create({
          informationId: 1,
          isSave: true,
          intInformation: decoded.termsOfServiceNo,
        })
        const encoded2 = pb.PlayerGeneralInformationReq.encode(message2).finish()
        this.post(cmdNo2, encoded2).catch(() => {
          this.$_error('Error', { title: 'ログインで登録', statusCode: 400 })
        })
      }).catch(() => {
        this.$_error('Error', { title: 'ログインで登録', statusCode: 400 })
      })
    },
    /**
     * 各SNSの利用規約確認ダイアログを開くか
     * @param {String} openFlag SessionStorageに格納しているフラグ
     * @param {String} flagName openTweetDialogかopenLineDialog
     */
    openSnsDialog(openFlag, flagName){
      if(openFlag === null){
        sessionStorage.setItem(flagName, false)
      } else if(openFlag === 'true'){
        this[flagName] = true;
      } else {
        return;
      }
    },
    /**
     * 各SNSの利用規約確認ダイアログ閉じる
     * @param {String} flagName openTweetDialogかopenLineDialog
     */
    closeSnsDialog(flagName){
      sessionStorage.setItem(flagName, false)
      this[flagName] = false;
      this.isChecked = false;
    }
  },
  async mounted() {
    let component = this
    this.getTwitterAccessToken.call(this).then(data =>{
      if (data === undefined) {
        return
      }
      component.onTwitterRegistration(data.token, data.tokenSecret, data.userId)
    }).catch(() => {
      this.$_error('Error', { title: 'ログインで登録', statusCode: 400 })
    })

    this.getLineAccessToken.call(this).then(data =>{
      if (data === undefined) {
        return
      }
      component.onLineRegistration(data.token, data.userId)
    }).catch(() => {
      this.$_error('Error', { title: 'ログインで登録', statusCode: 400 })
    })
    this.openSnsDialog(sessionStorage.getItem('openLineDialog'), 'openLineDialog')
    this.openSnsDialog(sessionStorage.getItem('openTweetDialog'), 'openTweetDialog')
  }
}
</script>

<style lang="scss" scoped>
.snsArea {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  .twitter { margin-left: 40px; }
}
.infoLink {
  margin-top: 20px;
  padding: 0 20px;
  cursor: pointer;
  & > div {
  margin-top: 15px;
  padding-right: 30px;
  text-align: right;
  font-size: 10px;
  color: #F63C5B;
  background-image:
    linear-gradient(to left, #F63C5B, #F63C5B),
    linear-gradient(45deg, transparent 47%, #F63C5B 49%, #F63C5B 51%, transparent 53%);
  background-repeat: no-repeat;
  background-size: 24px 1px, 8px 8px;
  background-position: right 70%, right 40%;
  }
}
.textArea {
  padding: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
.checkBox {
  margin: 30px auto 0;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;

  &__input {
    display: none;
  }

  &__custom {
    margin-right: 10px;
    display: block;
    position: relative;
    border: 1px solid #000;
    border-radius: 30%;
    width: 20px;
    height: 20px;
    cursor: pointer;

    &::before {
      content: '';
      position: absolute;
      width: 7px;
      height: 10px;
      top: 10%;
      left: 33%;
      border: 2px solid #000;
      border-top: none;
      border-left: none;
      transform: rotate(45deg);
      opacity: 0;
    }
  }
  .checkMark {
    &::before {
      content: '';
      opacity: 1;
    }
  }

  &__terms {
    color: #F63C5B;
    text-decoration: underline;
    cursor: pointer;
  }
}
.textLink { color: #DA2240; }

.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(#000, .5);
  z-index: 5000;
  .dialogInner {
    width: 345px;
    min-height: 200px;
    background-color: #fff;
    padding: 40px 15px;
    border-radius: 8px;
    position: relative;
      .closeBtn {
        position: absolute;
        width: 40px;
        height: 20px;
        top: 10px;
        right: 5px;
        outline: none;
        background-image:
          linear-gradient(
            20deg,
            transparent 0%,
            transparent 44%,
            #585757 50%,
            transparent 55%),
        linear-gradient(
          160deg,
          transparent 0%,
          transparent 44%,
          #585757 50%,
          transparent 55%);
        background-repeat: no-repeat;
        background-size: 28px 10px;
        background-position: 5px 5px, 5px 5px;
      }
    .dialogText {
      font-size: 12px;
      color: #373737;
    }
    .--textCenter {
      text-align: center;
    }
    .dialogBtn {
      & > .NormalBtn { margin: 20px 0px 0; }
    }
  }
}
</style>

